/* eslint-disable @typescript-eslint/no-explicit-any */
import { createApi } from "@reduxjs/toolkit/query/react";
import { apiFetchBaseQuery } from "@/redux/apiFetchBaseQuery";
import { DefaultApiSuccessResponse } from "@/types/ApiResponse";

export const userProfileSlice = createApi({
	reducerPath: "userProfileSlice",
	baseQuery: apiFetchBaseQuery,
	tagTypes: ["user"],
	endpoints: builder => ({
		updateUserProfile: builder.mutation<any, any>({
			query: data => ({
				url: "/user/profile",
				method: "PUT",
				body: data,
			}),
			invalidatesTags: ["user"],
		}),

		updateUserPassword: builder.mutation<any, any>({
			query: data => ({
				url: "/user/password",
				method: "PUT",
				body: data,
			}),
			invalidatesTags: ["user"],
		}),

		getUserProfileData: builder.query({
			query: userId => {
				return {
					url: `/user/${userId}`,
				};
			},
		}),

		updateAgencyContact: builder.mutation<any, any>({
			query: ({ agencyId, data }) => ({
				url: `/user/agency/${agencyId}/contact`,
				method: "PUT",
				body: data,
			}),
		}),

		getAgencyContactData: builder.query({
			query: agencyId => {
				return {
					url: `/user/agency/${agencyId}/contact`,
				};
			},
		}),

		getAgencyNotificationData: builder.query({
			query: agencyId => {
				return {
					url: `/user/agency/${agencyId}/notification/info`,
				};
			},
		}),

		updateAgencyNotification: builder.mutation<any, any>({
			query: ({ agencyId, data }) => ({
				url: `/user/agency/${agencyId}/notification/info`,
				method: "PUT",
				body: data,
			}),
		}),

		updateUserLoginNotification: builder.mutation<
			DefaultApiSuccessResponse,
			{ userId: number; data: { is_user_login_notification: "Y" | "N"; user_login_webhook_url: string | null } }
		>({
			query: ({ userId, data }) => ({
				url: `/user/profile/user-login-notification/${userId}`,
				method: "PUT",
				body: data,
			}),
		}),
	}),
});

export const {
	useGetUserProfileDataQuery,
	useUpdateUserProfileMutation,
	useUpdateUserPasswordMutation,
	useUpdateAgencyContactMutation,
	useGetAgencyContactDataQuery,
	useGetAgencyNotificationDataQuery,
	useUpdateAgencyNotificationMutation,
	useUpdateUserLoginNotificationMutation,
} = userProfileSlice;
